import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../services/login.service';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';
import { NotifierService } from 'angular-notifier';
import { LoggingService } from '../services/logging.service';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { VersionCheckService } from '../core/services/version-check.service';


@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.scss']
})
export class UserLoginComponent implements OnInit, OnDestroy {
  public isMobileDevice: boolean = false;
  accessRoles: any;
  hide = true;
  errorText: any;
  errorTextPasswordCounter: any;
  public errorSocialLogin: boolean = false;
  userEmail: string = '';
  loginFormV: FormGroup;

  constructor(private router: Router,
    public LoginService: LoginService,
    private sidePanelService: SidePanelService,
    private notifier: NotifierService,
    private activeRoute: ActivatedRoute,
    private LoggingService: LoggingService, private fb: FormBuilder, 
    private http: HttpClient,
    private versionCheckService: VersionCheckService
  ) {
    this.LoginService.loginBtnControl = { "btnOff": true, "btnLogin": false, "loginPassword": false, "loginOtp": false, "hideOtpResend": true, "showOtpResend": false, "isUnKnownUser": false };
  }


  ngOnDestroy(): void {
    this.btnBack();
  }

  ngOnInit() {
    let access = JSON.parse(localStorage.getItem('access'));
    let userLoginEmail = localStorage.getItem('user_login_email');
    localStorage.removeItem('redirectUrl');
    // check if user is already logged in
    // console.log("userLoginEmail ====> ", userLoginEmail);
    // console.log("access ====> ", access);
    if (access && access.access_rules && access.access_rules.side_drawer) {
      const httpPostOptions =    {
        headers:new HttpHeaders().set('Content-Type', 'application/json'),
        withCredentials: true
      }  
      this.http.post<any>(environment.apiUrl + `/api/user/checksession`,{},httpPostOptions)
        .subscribe((data) =>{
          if(data && data.status){
            this.sidePanelService.afterLoginNavigate();
          }else{
            this.LoginService.logout();
            this.router.navigate(['/login']);
          }
        });

    }
    this.activeRoute.queryParams.subscribe((result) => {
      if (result['email'] && result['email'] != '' && result['type']) {
        this.loginFormV = this.fb.group({
          username: [result['email'], [Validators.required, Validators.email]],
          otp: [''],
        })
        result['type'] === 'otp' ? this.onclickOtp() : this.onclickPassword();
      }
      else if (result['email'] && result['email'] != '' && !result['type']) {
        this.loginFormV = this.fb.group({
          username: [result['email'], [Validators.required, Validators.email]],
          otp: [''],
        })
      }
      else {
        this.loginFormV = this.fb.group({
          username: ['', [Validators.required, Validators.email]],
          otp: [''],
        })
      }
    })
  }
  validateMobileLogin = () => {
    if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(navigator.userAgent)) {
      return 1
    }
    return 0;
  }

  login(event:any) {
    event.preventDefault();
    if (this.loginFormV.value.otp && this.loginFormV.value.otp != '') {
      this.LoginService.loginOtp(this.loginFormV.value.username, this.loginFormV.value.otp)
        .pipe(map(data => {
          if (data.message == 'Success') {
            this.accessRoles = JSON.parse(localStorage.getItem('access'));
            if (this.accessRoles.org_id == 'd69b3bb6-3133-11e9-8d02-42010aa0000d') {
              localStorage.setItem('isITC', '1');
            }
            localStorage.setItem('user_login_email', this.loginFormV.value.username);
            this.LoginService.getTermAndCond().subscribe((data) =>{
              if(data.status){
                this.LoginService.termandCondType = data.type || '';
                this.router.navigate(['/tnc']);
              }else{
                setTimeout(() => {
                  const {redirect} = window.history.state;
                  if(redirect && !redirect.includes('login')) {
                    this.sidePanelService.afterLoginNavigate();
                  }else{
                    this.sidePanelService.checkGuestAccountAccess();
                    this.router.navigate(['/home-dashboard']);
                  }
                  this.versionCheckService.checkVersionOnLogin();
                  // this.sidePanelService.afterLoginNavigate();
                })
              }
            })
            // this.LoginService.getTermAndCond().subscribe((data) => {
            //   if (data.status) {
            //     this.router.navigate(['/tnc'], { state: { redirect: window.location.pathname } });
            //   } else {
            //     setTimeout(() => {
            //       const {redirect} = window.history.state;
            //       if(redirect && !redirect.includes('login')) {
            //         this.sidePanelService.afterLoginNavigate();
            //       }else{
            //         this.router.navigate(['/home-dashboard']);
            //       }
            //     })

            //   }
            // })

          }
          else {
            this.errorText = data.message;
            this.LoginService.loginBtnControl.showOtpResend = true;
            if (this.errorText) { this.notifier.notify('error', this.errorText) };

          }
        }))
        .subscribe(data => {
        });
    }
  }

  clearError() {
    this.errorText = '';
  }

  onclickOtp() {
    if (this.loginFormV.value.username && this.loginFormV.value.username != '') {
      this.userEmail = this.loginFormV.value.username;
      if(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.userEmail)) {
        this.errorText = '';
        this.LoginService.verfiyUser(this.loginFormV.value.username, 'loginOtp');
      } else {
        this.notifier.notify('error', 'Please Enter Valid Email ID');
      }
    } else {
      this.notifier.notify('error', 'Please Enter Email ID');
    }
  }

  onOtpResend() {
    this.loginFormV.get('otp').reset();
    setTimeout(() => {
      this.onclickOtp();
    }); 
  }

  onclickPassword() {
    if (this.loginFormV.value.username && this.loginFormV.value.username != '') {
      this.LoginService.verfiyUser(this.loginFormV.value.username, 'loginPassword');
    } else {
      this.notifier.notify('error', 'Please enter email ID');
    }
  }

  btnBack() {
    this.LoginService.loginBtnControl.loginOtp = false;
    this.LoginService.loginBtnControl.hideOtpResend = true;
    this.LoginService.loginBtnControl.showOtpResend = false;
    this.LoginService.loginBtnControl.btnLogin = false;
    this.LoginService.loginBtnControl.btnOff = true;
    this.loginFormV.controls['otp'].reset();
    this.errorText = '';
    clearInterval(this.LoginService.intervalCall);
  }

  googleLogin() {
    this.errorSocialLogin = false;
    let baseUrl = window.location.origin;
    let windowLoginUrl;
    switch (baseUrl) {
      case 'https://research.crownit.in':
        windowLoginUrl = 'https://reports.crownit.in';
        break;
      case 'https://research.eagleinsights.in':
        windowLoginUrl = 'https://reports.eagleinsights.in';
        break;
      default:
        windowLoginUrl = environment.apiUrl;
        break;
    }

    windowLoginUrl += '/auth/sso/login';
    console.log('windowLoginUrl', windowLoginUrl);
    var loginwindow = window.open(windowLoginUrl, "mywindow", "location=1,status=1,scrollbars=1, width=800,height=800");
    if (!loginwindow) {
      this.notifier.notify('error', 'Please allow popups for this site');
    } else {
      console.log('Popup opened successfully');
    }

    let listener = window.addEventListener('message', async (message: any) => {
      if (message.data.responseCode == 1) {
        localStorage.setItem('access', JSON.stringify(message.data.userDetails));
        this.LoggingService.logInfo(message.data.message);
        this.accessRoles = JSON.parse(localStorage.getItem('access'));
        if (this.accessRoles.org_id == 'd69b3bb6-3133-11e9-8d02-42010aa0000d') {
          localStorage.setItem('isITC', '1');
        }

        setTimeout(() => {
          loginwindow.close();
          this.LoginService.getTermAndCond().subscribe((data) =>{
            if(data.status){
              this.LoginService.termandCondType = data.type || '';
              this.router.navigate(['/tnc']);
            }else{
              const {redirect} = window.history.state;
              if(redirect && !redirect.includes('login')) {
                this.sidePanelService.afterLoginNavigate();
              }else{
                this.router.navigate(['/home-dashboard']);
              }
              // this.sidePanelService.afterLoginNavigate();
            }
            this.versionCheckService.checkVersionOnLogin();
          })
        })
        // setTimeout(() => {
        //   const {redirect} = window.history.state;
        //   if(redirect && !redirect.includes('login')) {
        //     this.sidePanelService.afterLoginNavigate();
        //   }else{
        //     this.router.navigate(['/home-dashboard']);
        //   }
        // })
        // loginwindow.close();
        this.LoginService.clearLocalStorageEmail();
      }
      if (message.data.responseCode == 0) {
        this.notifier.notify('error', message.data.message);
        loginwindow.close();
        this.errorSocialLogin = true;
      }
    });

  }

}
